module.exports = __webpack_public_path__ + "static/media/green.5289b1c9.png";